import React from 'react';

import {
  Wrapper,
  SelectTitle,
  SearchContainer,
  SearchInput,
  ItemList,
  Item,
  EmptyItem,
} from './styles';
import Icon from 'components/Icon';
import i18n from '../../i18n';

export interface IItems {
  id: number | string;
  title: string;
  [key: string]: any;
}

interface ISearchableSelectProps {
  text: string;
  items: IItems[];
  selectedItemId?: number | string | null;
  onSelectItem: (item: IItems) => void;
}

interface ISearchableSelectState {
  selecting: boolean;
  searchTerm: string;
}

class SearchableSelect extends React.PureComponent<
  ISearchableSelectProps,
  ISearchableSelectState
> {
  state = {
    selecting: false,
    searchTerm: '',
  };

  searchInput: any = React.createRef();

  componentDidUpdate(
    _prevProps: ISearchableSelectProps,
    prevState: ISearchableSelectState
  ) {
    if (!prevState.selecting && this.state.selecting) {
      this.searchInput.current.focus();
    }
  }

  handleSwitchSelecting = () => {
    this.setState((prevState) => ({
      selecting: !prevState.selecting,
      searchTerm: '',
    }));
  };

  handleChangeSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchTerm = e.target.value;
    this.setState({ searchTerm });
  };

  handleActionsBasedOnKey = (e: React.KeyboardEvent) => {
    // user enters ENTER KEY and input is not empty
    if (e.which === 13 && this.state.searchTerm.length > 0) {
      const filteredItems = this.props.items.filter((item) =>
        item.title.includes(this.state.searchTerm)
      );
      const [firstItem] = filteredItems;
      this.handleSelectItem(firstItem)();
    }
  };

  handleSelectItem = (item: IItems) => () => {
    this.props.onSelectItem(item);
    this.setState({ selecting: false });
  };

  render() {
    const { text, items, selectedItemId } = this.props;
    const selectedItem = items.find((item) => item.id === selectedItemId);
    const filteredItems = items.filter((item) =>
      item.title.includes(this.state.searchTerm)
    );
    return (
      <Wrapper>
        <SelectTitle onClick={this.handleSwitchSelecting}>
          {selectedItem ? (
            <span>{selectedItem.title}</span>
          ) : (
            <span style={{ color: 'silver' }}>{text}</span>
          )}
          <Icon type={this.state.selecting ? 'chevron-up' : 'chevron-down'} />
        </SelectTitle>
        {this.state.selecting && (
          <React.Fragment>
            <SearchContainer>
              <SearchInput
                type="text"
                placeholder={i18n.t('search', { ns: 'survey' }) as string}
                onChange={this.handleChangeSearchInput}
                onKeyDown={this.handleActionsBasedOnKey}
                value={this.state.searchTerm}
                ref={this.searchInput}
              />
            </SearchContainer>
            <ItemList>
              {filteredItems.map((item) => (
                <Item key={item.id} onClick={this.handleSelectItem(item)}>
                  {item.title}
                </Item>
              ))}
              {filteredItems.length < 1 && (
                <EmptyItem>
                  {i18n.t('noItem', { ns: 'survey' }) as string}
                </EmptyItem>
              )}
            </ItemList>
          </React.Fragment>
        )}
      </Wrapper>
    );
  }
}

export default SearchableSelect;
